<template>
  <div class="reader-selector">
    <div class="reader-selector--selected" @click="open = !open">
      <div class="title">
        <StateButton :reader-id="currentReader" :populated="true" />
        <div class="label">{{ currentTitle }}</div>
      </div>
      <div class="chevron"><icon name="chevron-down" /></div>
    </div>
    <div class="reader-selector--options" v-if="open">
      <ReaderOption
         v-for="option in options"
         :key="option.readerId"
         :readerId="option.readerId"
         :title="option.title"
         @selected="onSelected"
      />
    </div>
  </div>
</template>

<script>
  import ReaderOption from './ReaderOption.vue';
  import StateButton from '../ReaderStateButtons/StateButton.vue';

  export default {
    props: ['value', 'options', 'currentReader', 'currentTitle'],
    components: { ReaderOption, StateButton },
    data() {
      return {
        open: false,
      };
    },
    methods: {
      onSelected(reader) {
        this.$emit('input', reader);
        this.open = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '../../variables';
  #app[data-locale="ar"] .reader-selector {
    direction: rtl;
    font-family: $ar-font-family;
    font-size: $ar-default-font-size;
  }
  #app[data-locale="ar"] .reader-selector--selected {
    .title {
      display: flex;
      .label {
        padding-left: 0;
        padding-right: 8px;
      }
    }
  }

  .reader-selector {
    position: relative;
    width: calc(100% - 20px);
    margin: 0 10px;
  }
  .reader-selector--options {
    position: absolute;
    top: 40px; left: 0; right: 0;
    border: 1px solid $gray-300;
    background: $white;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.12);
    z-index: 999;
  }
  .reader-selector--selected {
    border: 1px solid $gray-300;
    border-radius: 3px;
    padding: 0.5rem 0.75rem;
    display: flex;
    justify-content: space-between;
    cursor: pointer;

    .title {
      display: flex;
      .label {
        padding-left: 5px;
        margin: auto 0;
      }
    }

    &:hover {
      .chevron {
        color: $gray-800;
      }
    }
  }
  .chevron {
    color: $gray-500;
  }
</style>
